module.exports = __webpack_public_path__ + "static/media/registp02_en.ac6659d6.png";